import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input} from 'react-bootstrap'
import {DEFAULT_AGENCY_QUERY, queryAgencyStream, queryHoldingAgencyStream} from '../actions'
import i18n from '../i18n'

function agencyFilter(agencies) {
    return (agency) => {
        return agencies.find((a) => a.uid == agency.uid) != null
    }
}

class AgencySelectInput extends Component {
    static propTypes = {
        user: PropTypes.object,
        company: PropTypes.object,
        agency: PropTypes.object,
        disable: PropTypes.func
    }

    static defaultProps = {
        disable: (v) => false
    }

    constructor(props) {
        super(props)

        this.state = {
            agencies: []
        }
    }

    componentWillMount() {
        const {dispatch, user, company, agency} = this.props

        if (agency) {
            this.setState({agencies: [agency]})
        } else if (company && company.companyType == 'ClientAccountHolding') {
            dispatch(queryHoldingAgencyStream({...DEFAULT_AGENCY_QUERY, holdingUid: company.uid, range: {offset: 0, limit: 99}}))
        } else if (company) {
            dispatch(queryAgencyStream({...DEFAULT_AGENCY_QUERY, companyUid: company.uid, range: {offset: 0, limit: 99}}))
        } else if (user && user.company && user.isPartOfHolding) {
            dispatch(queryHoldingAgencyStream({...DEFAULT_AGENCY_QUERY, holdingUid: user.company.uid, range: {offset: 0, limit: 99}}))
        } else if (user && user.company) {
            dispatch(queryAgencyStream({...DEFAULT_AGENCY_QUERY, companyUid: user.company.uid, range: {offset: 0, limit: 99}}))
        } else if (user) {
            this.setState({agencies: user.managedAgencies || []})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user != this.props.user
            || nextProps.company != this.props.company
            || nextProps.agency != this.props.agency) {
            const {dispatch, user, company, agency} = this.props

            if (agency) {
                this.setState({agencies: [agency]})
            } else if (company && company.companyType == 'ClientAccountHolding') {
                dispatch(queryHoldingAgencyStream({...DEFAULT_AGENCY_QUERY, holdingUid: company.uid, range: {offset: 0, limit: 99}}))
            } else if (company) {
                dispatch(queryAgencyStream({...DEFAULT_AGENCY_QUERY, companyUid: company.uid, range: {offset: 0, limit: 99}}))
            } else if (user && user.company && user.isPartOfHolding) {
                dispatch(queryHoldingAgencyStream({...DEFAULT_AGENCY_QUERY, holdingUid: user.company.uid, range: {offset: 0, limit: 99}}))
            } else if (user && user.company) {
                dispatch(queryAgencyStream({...DEFAULT_AGENCY_QUERY, companyUid: user.company.uid, range: {offset: 0, limit: 99}}))
            } else if (user) {
                this.setState({agencies: user.managedAgencies || []})
            }
        }

        if (nextProps.stream != this.props.stream) {
            const {user, stream} = nextProps
            const agencies = user && user.managedAgencies && user.managedAgencies.filter(agencyFilter(stream)) || stream

            this.setState({agencies})
        }
    }

    render() {
        const {children, dispatch, stream, user, company, agency, disable, ...others} = this.props
        const {agencies} = this.state

        return (
            <Input
                type='select'
                {...others}>
                {children}
                {agencies.map((agency, index) => !disable(agency) && (
                    <option
                        key={index}
                        value={agency.uid}>
                        {agency.label}
                    </option>
                ))}
            </Input>
        )
    }
}

AgencySelectInput = connect((state) => ({
    stream: state.company.agency.stream
}))(AgencySelectInput)

export default AgencySelectInput


// WEBPACK FOOTER //
// ./lib/company/components/AgencySelectInput.js